import { css } from 'lit';
         export default css` 
         @charset "UTF-8";
/* ------------------------------------*\
    #BREAKPOINT VARIABLES
\*------------------------------------ */
/* ------------------------------------*\
    #TYPOGRAPHY APPLICATIONS
\*------------------------------------ */
/**
   * Visible focus outline 2px inside the element on a light background
   */
/**
   * Visible focus outline 2px inside the element on a dark background
   */
/**
   * Visible focus outline for elements on a light background
   */
/**
   * Invisible focus outline for elements that need a more visible
   * focus state for high-contrast mode
   */
/**
   * Visually hidden from display
   */
/**
   * style for text ellipsis
   */
/**
   * Popover attribute has default styling which comes from UA stylesheets which will be overridden here.
   */
/* ------------------------------------*\
    #VISIBILITY UTILITIES
\*------------------------------------ */
/* Completely remove from the flow and screen readers. */
.cat-u-is-hidden {
  display: none !important;
  visibility: hidden !important;
}

/* Completely remove from the flow but leave available to screen readers. */
.cat-u-is-vishidden {
  position: absolute !important;
  overflow: hidden;
  width: 1px;
  height: 1px;
  padding: 0;
  border: 0;
  clip: rect(1px, 1px, 1px, 1px);
}

/**
 * Hide element at sm breakpoint 
 */
@media all and (min-width: 23.4375rem) {
  .cat-u-hide-sm {
    display: none !important;
  }
}

/**
 * Hide element at sm-2 breakpoint 
 */
@media all and (min-width: 35rem) {
  .cat-u-hide-sm-2 {
    display: none !important;
  }
}

/**
 * Hide element at md breakpoint 
 */
@media all and (min-width: 48rem) {
  .cat-u-hide-md {
    display: none !important;
  }
}

/**
 * Hide element at lg breakpoint 
 */
@media all and (min-width: 60rem) {
  .cat-u-hide-lg {
    display: none !important;
  }
}

/**
 * Hide element at xl breakpoint 
 */
@media all and (min-width: 75rem) {
  .cat-u-hide-xl {
    display: none !important;
  }
}

/**
 * Show element at sm breakpoint 
 */
@media all and (max-width: 23.4375rem) {
  .cat-u-show-sm {
    display: none !important;
  }
}

/**
 * Show element at sm-2 breakpoint 
 */
@media all and (max-width: 35rem) {
  .cat-u-show-sm-2 {
    display: none !important;
  }
}

/**
 * Show element at md breakpoint 
 */
@media all and (max-width: 48rem) {
  .cat-u-show-md {
    display: none !important;
  }
}

/**
 * Show element at lg breakpoint 
 */
@media all and (max-width: 60rem) {
  .cat-u-show-lg {
    display: none !important;
  }
}

/**
 * Show element at xl breakpoint 
 */
@media all and (max-width: 75rem) {
  .cat-u-show-xl {
    display: none !important;
  }
}

/* ------------------------------------*\
    #RESET
\*------------------------------------ */
/**
 * Border-Box http:/paulirish.com/2012/box-sizing-border-box-ftw/
 */
*,
::slotted(*),
*:before,
*:after {
  box-sizing: border-box;
}

:focus-visible {
  outline-color: var(--cat-theme-color-focus-ring);
}

/* ------------------------------------*\
    #ACCORDION-PANEL
\*------------------------------------ */
:host {
  display: block;
}

.cat-c-accordion-panel.cat-is-disabled {
  color: var(--cat-theme-color-content-disabled);
  cursor: not-allowed;
}

/**
* Accordion panel button
* 1) Icon rotating on open was causing scrollbars to continuously appear/disapear
*    during the animation, overflow-inline: hidden; prevents this from happening
*/
.cat-c-accordion-panel__button {
  display: flex;
  align-items: center;
  appearance: none;
  background: none;
  background-color: var(--cat-accordion-panel-background, var(--cat-theme-color-background-default));
  border: none;
  padding: calc(var(--size-base-unit) * 1.875) var(--cat-space-medium);
  width: 100%;
  cursor: pointer;
  color: inherit;
  position: relative;
  overflow-x: hidden; /* 1 */
  transition: background-color var(--cat-anim-fade-quick) var(--cat-anim-ease);
  /**
   * Accordion panel button large
   */
}
.cat-c-accordion-panel__button:hover:not(:disabled) {
  background-color: var(--cat-accordion-panel-hover-background, var(--cat-theme-color-background-subtle));
  border-color: var(--cat-theme-color-border-default-hover);
}
.cat-c-accordion-panel__button:focus:not(:focus-visible) {
  outline: none;
}
.cat-c-accordion-panel__button:focus-visible {
  outline: 2px solid var(--cat-theme-color-focus-ring);
  outline-offset: var(--cat-theme-inset-focus-ring, -4px);
  transition: all var(--cat-anim-fade-quick) var(--cat-anim-ease);
}
.cat-c-accordion-panel__button:disabled {
  color: var(--cat-theme-color-content-disabled);
  pointer-events: none;
  border-block-end-color: var(--cat-theme-color-border-disabled);
  border-block-start-color: var(--cat-theme-color-border-disabled);
}
.cat-c-accordion-panel--large .cat-c-accordion-panel__button {
  padding: calc(var(--size-base-unit) * 1.875) var(--cat-space-medium);
}
.cat-c-accordion-panel--toggle-right .cat-c-accordion-panel__button {
  justify-content: space-between;
}

/**
 * Accordion icon
 */
.cat-c-accordion-panel__icon {
  transition: transform var(--cat-anim-fade-quick) var(--cat-anim-ease);
  margin-inline-end: var(--cat-space-medium);
  --cat-icon-width: calc(var(--size-base-unit) * 2);
  --cat-icon-height: calc(var(--size-base-unit) * 2);
  /**
   * Right aligned accordion icon
   */
  /**
   * Accordion icon animation
   */
}
.cat-c-accordion-panel--toggle-right .cat-c-accordion-panel__icon {
  margin-inline: var(--cat-space-medium) 0;
}
.cat-c-accordion-panel.cat-is-active .cat-c-accordion-panel__icon {
  transform: rotate(-180deg);
}

/**
 * Slot before
 */
slot[name=before] {
  display: block;
  margin-inline-end: var(--cat-space-medium);
}

/**
 * Slot after
 */
slot[name=after] {
  display: block;
  margin-inline-start: var(--cat-space-medium);
}

/**
 * Accordion panel header
 */
.cat-c-accordion-header {
  margin-inline-end: auto;
  font-family: var(--cat-theme-typography-body-font-family);
  font-weight: var(--cat-theme-typography-body-font-weight);
  font-size: var(--cat-theme-typography-body-font-size);
  line-height: var(--cat-theme-typography-body-line-height);
  text-align: start;
  word-break: break-word;
  hyphens: auto;
  /**
   * Accordion panel header large
   */
}
.cat-c-accordion-panel--large .cat-c-accordion-header {
  font-family: var(--cat-theme-typography-title-font-family);
  font-weight: var(--cat-theme-typography-title-font-weight);
  font-size: var(--cat-theme-typography-title-font-size);
  line-height: var(--cat-theme-typography-title-line-height);
}
@media all and (width <= calc(48rem - 0.02px)) {
  .cat-c-accordion-panel--large .cat-c-accordion-header {
    font-size: var(--cat-theme-typography-title-mobile-font-size);
    line-height: var(--cat-theme-typography-title-mobile-line-height);
  }
}

/**
 * Accordion panel body
 * 1) Display set to none so user can't tab inside panel content while closed
 * 2) Using display css instead of visibility css, since visibility css removes the element from the a11y tree when changed dynamically.
 */
.cat-c-accordion-panel__body {
  margin: 0;
  overflow: auto;
  display: none; /* 1 */
  /**
   * Accordion panel body within active accordion panel
   * 1) Display set to block so user can tab within panel content when panel is open
   */
  /**
   * Allow scrolling if a panel height is present
   */
}
.cat-c-accordion-panel.cat-is-active .cat-c-accordion-panel__body {
  display: block;
}
.cat-c-accordion-panel.cat-c-accordion-panel--has-panel-height.cat-is-active .cat-c-accordion-panel__body {
  overflow: auto;
}

/**
 * Accordion panel body inner
 * Display should be none so that It will avoid overflow when it is not active
 */
.cat-c-accordion-panel__body-inner {
  padding: var(--cat-space-medium);
  padding-inline-start: var(--cat-space-4x-large);
  padding-block-start: calc(var(--size-base-unit) * 0.25);
  /**
    Align body with the header content when we use arrow icon on right
  */
}
.cat-c-accordion-panel--toggle-right .cat-c-accordion-panel__body-inner {
  padding: var(--cat-space-medium);
  padding-block-start: calc(var(--size-base-unit) * 0.25);
}

.cat-c-accordion-panel:not(.cat-c-accordion-panel--has-before) [part=part-before], .cat-c-accordion-panel:not(.cat-c-accordion-panel--has-after) [part=part-after] {
  display: none;
}
`;
       